import React, { useState } from 'react';
import {
  createRippleEffectRelative,
  getScreenName,
} from '../../../../Utils/helper';
import MultiCategoryBanner from '../../../CategoryL2Page/CategoryGeneralItemListing/MultiCategoryBanner';
import { GeneralSectionCover } from '../../../CategoryL2Page/CategoryGeneralItemListing/styled';
import { ProductListContainer } from '../../../MaternityWear/ProductList/styled';
import ProductCardNew from '../ProductCardNew/ProductCardNew';
import ExploreMoreBtn from './ExploreMoreBtn';
import { BestSellerHeading, ExploreBtnStyle } from './styled';
import { fireEvent } from '../../../../Utils/fireEvent';

const ExploreSubCatProducts = (props) => {
  const { data, horizontal, categoryId, isL1Category, generalItemIndex } =
    props;
  const productData = data;
  const [productsToShow, setProductsToShow] = useState(10);
  const bgColor = productData?.[0].sectionBgColorStart;
  const bgColorEnd = productData?.[0].sectionBgColorEnd;
  const gradient = `linear-gradient(180deg,${bgColor},${bgColorEnd})`;
  let isBestSeller = null;
  productData?.map((item) => {
    isBestSeller =
      item?.heading?.toLowerCase()?.includes('bestseller') ||
      item?.itemName?.toLowerCase()?.includes('bestseller');
  });

  return (
    <GeneralSectionCover>
      {productData?.map((item, index) => {
        return (
          <>
            {isBestSeller ? (
              <BestSellerHeading>Bestsellers</BestSellerHeading>
            ) : (
              <MultiCategoryBanner
                data={item?.headerCard}
                categoryId={categoryId}
                sectionData={item}
              />
            )}

            <ProductListContainer
              horizontal={horizontal}
              bgColor={bgColorEnd ? gradient : bgColor}
              location="category"
              horziontalCardView={
                item?.items?.[0]?.itemType == 'PRODUCT_LINEAR'
              }
            >
              {item?.items?.map((product, innerIndex) => {
                if (innerIndex < productsToShow)
                  return (
                    <ProductCardNew
                      key={innerIndex}
                      productInfo={product}
                      horizontal={horizontal}
                      sectionId={item?._id}
                      sectionName={item?.itemName}
                      categoryId={categoryId}
                      singleProduct={product?.itemType == 'PRODUCT_LINEAR'}
                    />
                  );
              })}
            </ProductListContainer>
            {item?.items?.length > 10 &&
            productsToShow < item?.items?.length &&
            !(item?.bottomViewAllCta?.text?.length > 0) ? (
              <ExploreBtnStyle
                showMore={true}
                onClick={(e) => {
                  createRippleEffectRelative(
                    e,
                    document.getElementById('showMore' + generalItemIndex),
                  );
                  fireEvent({
                    category: 'clicked_cta',
                    cta: 'Show more products',
                    section_name: item?.itemName,
                    section_id: item?._id,
                    screen_name: getScreenName(),
                    id: categoryId,
                  });
                  setTimeout(() => {
                    setProductsToShow((prev) => prev + 8);
                  }, 200);
                }}
                id={'showMore' + generalItemIndex}
              >
                Show more products
                <span></span>
              </ExploreBtnStyle>
            ) : null}
            {item?.bottomViewAllCta?.text?.length > 0 && (
              <ExploreMoreBtn
                index={generalItemIndex}
                data={item?.bottomViewAllCta}
                sectionData={item}
                categoryId={categoryId}
              />
            )}
          </>
        );
      })}
    </GeneralSectionCover>
  );
};

export default ExploreSubCatProducts;
